import { i18n } from "@src/utils/i18n";
import { routerConfig } from "./router-list";
import * as nls from "../nls";
import addMember from "../components/left-slider/assets/add_member.svg";
import baseInfo from "../components/left-slider/assets/baseinfo.svg";
import event from "../components/left-slider/assets/event.svg";
import permissions from "../components/left-slider/assets/permissions.svg";
import safeSetting from "../components/left-slider/assets/safe_seting.svg";
import weCode from "../components/left-slider/assets/wecode.svg";
import versionRelease from "../components/left-slider/assets/version_release.svg";
import log from "../components/left-slider/assets/log.svg";
import lightApps from "../components/left-slider/assets/light_apps.svg";
import robotApps from "../components/left-slider/assets/robot_apps.svg";
// 添加应用能力
import addApplication from "../components/left-slider/assets/add-application.svg";

const I18N = i18n(nls);
const subMenu = [
  {
    menuName: I18N["basicInformation"],
    children: [
      {
        //凭证与基础信息
        menuName: I18N.voucherAndBasicInformation,
        key: routerConfig.baseInfo,
        resUrl: routerConfig.baseInfo,
        icon: baseInfo
      },
      {
        //成员管理
        menuName: I18N.membersManage,
        key: routerConfig.membersManage,
        resUrl: routerConfig.membersManage,
        icon: addMember
      }
    ]
  },
  {
    menuName: I18N.applicationCapability,
    children: [
      {
        // 添加应用功能
        menuName: I18N.addAppCapabilities,
        key: routerConfig.addAppCapabilities,
        resUrl: routerConfig.addAppCapabilities,
        icon: addApplication,
        isHide: false
      },
      {
        //We码
        menuName: I18N.applicationWe,
        key: routerConfig.applicationWe,
        resUrl: routerConfig.applicationWe,
        icon: weCode,
        isHide: true
      },
      {
        //轻应用
        menuName: I18N.applicationLight,
        key: routerConfig.applicationLight,
        resUrl: routerConfig.applicationLight,
        icon: lightApps,
        isHide: true
      },
      {
        // 机器人
        menuName: I18N.applicationRobot,
        key: routerConfig.applicationRobot,
        resUrl: routerConfig.applicationRobot,
        icon: robotApps,
        isHide: true
      }
    ]
  },
  {
    menuName: I18N.developmentConfiguration,
    children: [
      {
        //权限管理
        menuName: I18N.permissionManagement,
        key: routerConfig.apiManage,
        resUrl: routerConfig.apiManage,
        icon: permissions
      },
      {
        //事件与回调
        menuName: I18N.eventsAndCallbacks,
        key: routerConfig.eventsAndCallbacks,
        resUrl: routerConfig.eventsAndCallbacks,
        icon: event
      },
      {
        //安全设置
        menuName: I18N["securitySettings"],
        key: routerConfig.securitySet,
        resUrl: routerConfig.securitySet,
        icon: safeSetting
      }
    ]
  },
  {
    menuName: I18N["applicationRelease"],
    children: [
      {
        //版本管理与发布
        menuName: I18N["versionManagementAndRelease"],
        key: routerConfig.editionManage,
        resUrl: routerConfig.editionManage,
        icon: versionRelease
      }
    ]
  },
  {
    menuName: I18N["operationAndMonitoring"],
    children: [
      {
        //日志检索
        menuName: I18N["logRetrieval"],
        key: routerConfig.logPage,
        resUrl: routerConfig.logPage,
        icon: log
      }
    ]
  }
];

export default subMenu;
